import React from 'react';
import { accreditations } from '../../data/accreditations';

// A slow, continuous strip of accreditation logos. Pauses on hover and stops for reduced motion.
export function AccreditationMarquee() {
  const list = [...accreditations, ...accreditations];
  return <section className="w-full overflow-hidden bg-white py-6" aria-label="Accredited and recognised by" data-id="element-414" data-mp="qszw1y5u3bwh">
      <ul className="flex w-max animate-marquee items-center hover:[animation-play-state:paused] motion-reduce:animate-none" data-id="element-415" data-mp="3v9k9ghj8jd5b">
        {list.map((item, index) => <li key={`${item.name}-${index}`} className="flex shrink-0 items-center px-6 md:px-10" aria-hidden={index >= accreditations.length} data-id="element-416" data-mp="3qcalz7fepbk4" data-mpi={index}>
            <img src={item.logo} alt={index >= accreditations.length ? '' : item.name} className="h-20 w-auto object-contain md:h-24" loading="lazy" data-id="element-417" data-mp="3604faccrc6p" />
          </li>)}
      </ul>
    </section>;
}